export const IMPORT_ITEMS_MANDATORY_COLUMNS = ["nome", "preço"];

export const FISCAL_COLUMNS_NAMES = [
  "icms_situacao_tributaria",
  "icms_aliquota",
  "icms_origem",
  "pis_situacao_tributaria",
  "pis_aliquota",
  "cofins_situacao_tributaria",
  "cofins_aliquota",
];
